import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-item-start',
  templateUrl: './item-start.component.html',
  styleUrls: ['./item-start.component.scss']
})
export class ItemStartComponent implements OnInit {

  title : string = "جرد";
  type :string =  "in";
  isInventory : boolean = true;

  constructor() { }

  ngOnInit() {
  }

}
